var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVector1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 60,
    viewBox: "0 0 79 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector 3",
    d: "M0 58.5018L11.3592 0.213867H51.3036L46.9346 22.9299H57.1704C54.3698 33.9869 49.9616 37.6324 31.4562 34.5376L36.1996 11.4471H23.0928L16.4771 45.8956C53.1626 47.9892 63.3307 45.2017 66.5324 34.5376H78.3908C73.5226 58.5018 55.7567 61.9588 0 58.5018Z",
    fill: "#F8B232"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector1);
export default __webpack_public_path__ + "static/media/Vector1.81d0e65aaf3736197a27fb9a7cae2161.svg";
export { ForwardRef as ReactComponent };